import { Component, Input } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

@Component({
    selector: 'ngx-multilang-edit-modal',
    templateUrl: 'multilang-edit-modal.component.html',
    styleUrls: ['multilang-edit-modal.component.scss'],
    standalone: false
})
export class MultilangEditModalComponent {

  originalModel;

  _model;
  @Input() set model(model){
    this._model = {...model};
    this.originalModel = model;
  };

  @Input() languages = [];
  @Input() defaultLang;
  @Input() editMode = false;
  @Input() htmlMode = true;

  constructor(protected ref: NbDialogRef<MultilangEditModalComponent>) {}

  cancel() {
    this.ref.close();
  }

  save() {
    //this.originalModel = this._model;
    Object.assign(this.originalModel, this._model);
    this.ref.close(this.originalModel);
  }
}
